// SCSS - Dependency
require('css/index.scss');

// JS - Dependency
require('js/index.js');

// HBS - Base Layout
require('app/layouts/base.hbs');

// HBS - Pages
require('app/pages/index.hbs');
require('app/pages/all-products-browse.hbs');
require('app/pages/all-products-booking.hbs');

// HBS - Components



// WEBPACK FOOTER //
// ./src/app.js